import {
  KeyboardArrowDown,
  KeyboardArrowRight,
  ImageOutlined,
} from '@mui/icons-material';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import React from 'react';
import SectionPartRow from './SectionPartRow/SectionPartRow';
import { tableHeaders } from '../SectionTable';
import { SectionInfo } from '../../../PartSelection';
import { OPTION_PARTS_ATTRIBUTES } from '../../../../../_constants/inspectionConst';

type SectionRowProps = {
  sectionIndex: number;
  section: SectionInfo;
  isExpanded: boolean;
  isShowOptionParts: boolean;
  toggleAccordion: (index: number) => void;
  onChangeSelection: (
    isChecked: boolean,
    listNo: string,
    inFigureNo: string,
  ) => void;
  onChangePartsCode: (
    newPartsCode: string,
    listNo: string,
    inFigureNo: string,
  ) => void;
  onChangeAmount: (
    newAmount: string,
    listNo: string,
    inFigureNo: string,
  ) => void;
  handlePartsListImage: (isometricDrawing: string, section: string) => void;
};

/** セクション1つ分 */
const SectionRow: React.FC<SectionRowProps> = ({
  sectionIndex,
  section,
  isExpanded,
  isShowOptionParts,
  toggleAccordion,
  onChangeSelection,
  onChangePartsCode,
  onChangeAmount,
  handlePartsListImage,
}) => {
  return (
    <React.Fragment key={sectionIndex}>
      {/* セクション名を表示する行 */}
      <TableRow key={`${section.name}_${sectionIndex}`}>
        {/* 開閉アイコン */}
        <TableCell
          sx={{
            p: tableHeaders[0].p,
            width: tableHeaders[0].width,
            minWidth: tableHeaders[0].minWidth,
          }}
        >
          <IconButton
            size="small"
            onClick={() => toggleAccordion(sectionIndex)}
          >
            {isExpanded ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </IconButton>
        </TableCell>
        {/* セクション名 */}
        <TableCell
          colSpan={8}
          sx={{
            height: '3.5rem',
            p: tableHeaders[1].p,
            width: tableHeaders[1].width,
            minWidth: tableHeaders[1].minWidth,
          }}
        >
          {section.name}
        </TableCell>
        {/* パーツリストアイコン */}
        <TableCell
          sx={{
            p: tableHeaders[9].p,
            width: tableHeaders[9].width,
            minWidth: tableHeaders[9].minWidth,
          }}
        >
          <Link
            to="#"
            onClick={() =>
              handlePartsListImage(
                section.partsList[0].isometricDrawing, // 先頭パーツのリンクを設定
                section.name,
              )
            }
          >
            <ImageOutlined
              sx={{
                display: section.partsList[0].isometricDrawing
                  ? 'flex'
                  : 'none',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                cursor: 'pointer',
                opacity: 0.7,
                color: 'black',
                '&:hover': {
                  transform: 'scale(1.2)',
                  opacity: 1,
                },
              }}
            />
          </Link>
        </TableCell>
        {/* ECN列分の空セル */}
        <TableCell />
      </TableRow>
      {/* セクションに紐づくパーツ */}
      {section.partsList.map((part, partIndex) => (
        <TableRow key={partIndex}>
          {isExpanded &&
            (isShowOptionParts || // オプションパーツの表示制御
              !OPTION_PARTS_ATTRIBUTES.includes(part.partsAttribute)) && (
              <SectionPartRow
                index={partIndex}
                part={part}
                sectionName={section.name}
                onChangeSelection={onChangeSelection}
                onChangePartsCode={onChangePartsCode}
                onChangeAmount={onChangeAmount}
                handlePartsListImage={handlePartsListImage}
              />
            )}
        </TableRow>
      ))}
    </React.Fragment>
  );
};
export default SectionRow;
